import countries from '@/js/common/Domain/Hydrator/fromRouter/countries';
import operators from '@/js/common/Domain/Hydrator/fromRouter/operators';
import resorts from '@/js/common/Domain/Hydrator/fromRouter/resorts';
import checkInDateRange from '@/js/common/Domain/Hydrator/fromRouter/checkInDateRange';
import nightRange from '@/js/common/Domain/Hydrator/fromRouter/nightRange';
import touristGroup from '@/js/common/Domain/Hydrator/fromRouter/touristGroup';
import hotelCategories from '@/js/common/Domain/Hydrator/fromRouter/hotelCategories';
import meals from '@/js/common/Domain/Hydrator/fromRouter/meals';
import hotels from '@/js/common/Domain/Hydrator/fromRouter/hotels';
import priceRange from '@/js/common/Domain/Hydrator/fromRouter/priceRange';

import '@/js/common/plugins/jquery.unparam.min';

export default (urlParams) => {
    if (typeof urlParams !== 'string') {
        return null;
    }

    const params = $.unparam(urlParams);

    const tourCriteria = {
        ...countries(params),
        ...operators(params),
        ...resorts(params),
        ...checkInDateRange(params),
        ...nightRange(params),
        ...touristGroup(params),
        ...hotelCategories(params),
        ...meals(params),
        ...hotels(params),
        ...priceRange(params),
    };

    const other = _.omit(params, 'fromCity', 'toCountry', 'operators', 'toCity', 'dateFrom', 'dateTo', 'dateFlexible', 'nightFrom', 'nightTo',
        'adults', 'ages', 'kids', 'infants', 'hotelClass', 'meal', 'hotels', 'priceFrom', 'priceTo');

    return {
        tourCriteria,
        other,
    };
};